export const HELP_SUPPORT_REWARDS_ENTRY_EMAIL_DEVICE_SWAP = 'HELP_SUPPORT_REWARDS_ENTRY_EMAIL_DEVICE_SWAP';
